/**
 * All possible statuses of a task's payment order in 1C ERP database.
 * Enumeration with Russian words as constants (1C ERP enumeration type).
 */
export enum TaskOrder1cStatusEnum {
  /** Payment is ready (initial status) */
  READY = 'Подготовлено',
  /** Payment order was sent to counterparty */
  SENT = 'Отправлено',
  /** Payment order was paid */
  PAID = 'Оплачено',
  /** Payment order was refused */
  REFUSED = 'Отклонено',
}
